<template>
  <Wrapper>
    <main class="main">
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}result` }"
            class="breadcrumb-trail__list--item__link"
          >
            Results
          </router-link>
        </li>
      </ol>
      <h1 class="page-title">Results</h1>
      <ul class="result__list">
        <li
          class="result__list--item"
          v-for="(dataEvent, index) in dataEventList"
          :key="index"
        >
          <router-link
            :to="{
              path: `/${langPath}${
                dataEvent.text.team_event_code ? 'company/' : ''
              }ranking`,
              query: {
                event: `${
                  dataEvent.text.team_event_code
                    ? dataEvent.text.team_event_code
                    : dataEvent.code
                }`,
                page: 1,
              },
            }"
            class="link"
          >
            <dl class="result-item-dl">
              <dd class="description-date">{{ dataEvent.text.event_date }}</dd>
              <dd class="blue-line"></dd>
              <dt class="team-title">{{ dataEvent.name }}</dt>
            </dl>
            <figure class="result-item-figure">
              <img
                :src="`https://tmf-virtualrun.jp/images/${dataEvent.text.event_image_file_name}`"
                alt=""
                height="100px"
              />
            </figure>
          </router-link>
        </li>
      </ul>
    </main>
  </Wrapper>
</template>

<script>
import { RepositoryFactory } from "../../../api/RepositoryFactory";
import Wrapper from "../../../components/pc/Wrapper";
export default {
  data() {
    return {
      dataEventList: [],
    };
  },
  async created() {
    const EventRepository = RepositoryFactory.get("event");
    const params = {
      lang: this.lang,
      eventPeriod: true,
    };
    const response = await EventRepository.getEventList(params);
    this.dataEventList = response.data.items;
  },
  computed: {
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Wrapper,
  },
  name: "Result",
};
</script>

<style scoped lang="scss">
$blueFoundationColor: #0093e6;
.main {
  text-align: center;
  .page-title {
    display: inline-block;
    margin: 96px 0 0 0;
    padding: 0 0 8px 0;
    line-height: 1;
    font-size: 100px;
    font-weight: 900;
    &::after {
      content: "";
      display: block;
      height: 10px;
      background: url("../../../assets/images/border/border_results.svg");
      margin-top: 8px;
    }
  }
  .result__list {
    margin: 94px 0 0 0;
    text-align: left;
    &--item {
      border-bottom: solid 1px #000;
      .link {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 28px 0;
        &:hover {
          background-color: #eee;
          transition-duration: 0.3s;
        }
        .result-item-dl {
          .description-date {
            font-size: 20px;
            font-weight: bold;
          }

          .blue-line {
            margin: 14px 0;
            width: 60px;
            border-top: solid 3px $blueFoundationColor;
          }

          .team-title {
            font-size: 24px;
            font-weight: bold;
          }
        }

        .result-item-figure {
          margin: 0 0 0 100px;
          padding: 13px 10px;
          border: solid 1px #eee;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/result/Result.vue